import React from 'react';
import { useChatUnread } from '../../hooks/chat/useChatUnread';

interface ChatBadgeProps {
  className?: string;
  // When false, render the raw number with no positioning — useful inline.
  positioned?: boolean;
}

const ChatBadge: React.FC<ChatBadgeProps> = ({ className, positioned = true }) => {
  const { data } = useChatUnread();
  const total = data?.total_unread ?? 0;
  if (total <= 0) return null;

  const baseClass = positioned
    ? 'min-w-[20px] h-[18px] px-1 rounded-[5px] flex items-center justify-center text-[10px] font-bold leading-none'
    : 'min-w-[34px] h-6 px-2 rounded-md flex items-center justify-center text-xs font-bold leading-none';
  const positionClass = positioned ? 'absolute -top-1 -right-1.5' : '';
  return (
    <span
      className={`${baseClass} ${positionClass} bg-primary-200 text-primary-900 ${className ?? ''}`}
    >
      {total > 99 ? '99+' : total}
    </span>
  );
};

export default ChatBadge;
